export enum BiobakeryVersion {
  BB3 = 'biobakery_3',
  BB4 = 'biobakery_4',
}

export const BiobakeryVersionLabel: Record<
  BiobakeryVersion,
  keyof typeof BiobakeryVersion
> = {
  [BiobakeryVersion.BB3]: 'BB3',
  [BiobakeryVersion.BB4]: 'BB4',
};

export enum BBOutputType {
  TAXONOMIC_PROFILE = 'taxonomic_profile',
  FUNCTIONAL_PROFILE = 'functional_profile', //Taxonomic + Functional Profile
}

export const shotgunOutputTypes: Record<BiobakeryVersion, BBOutputType[]> = {
  [BiobakeryVersion.BB3]: [BBOutputType.FUNCTIONAL_PROFILE],
  [BiobakeryVersion.BB4]: Object.values(BBOutputType),
};

export enum BiobakeryPipeline {
  SIXTEEN_S = '16s',
  SHOTGUN = 'shotgun',
}
